<template>
  <div class="spl-pudo-filter">
    <div v-if="useDate" class="spl-pudo-filter__date--from">
      <form-label>From</form-label>
      <form-datepicker
        v-model="dateFrom" />
    </div>
    <div v-if="useDate" class="spl-pudo-filter__date--to">
      <form-label>To</form-label>
      <form-datepicker
        v-model="dateTo" />
    </div>
    <div class="spl-pudo-filter__date--from">
      <form-label>Country</form-label>
      <country-select
        v-model="Country"
        @input="saveCountry" />
    </div>
    <div>
      <form-label>Customer</form-label>
      <customer-select
        v-model="Customer"
        @input="saveCustomer" />
    </div>
    <form-button class="spl-pudo-filter__apply" @onClick="emitChange()">
      Apply
    </form-button>
  </div>
</template>

<script>
import moment from 'moment'
import { find } from 'lodash'
import { mapGetters, mapState, mapMutations } from 'vuex'
export default {
  props: ['useDate', 'value'],
  data () {
    return {
      dateFrom: moment().subtract(2, 'weeks').toISOString(true),
      dateTo: moment().endOf('day').toISOString(true),
      Country: null,
      Customer: null
    }
  },
  computed: {
    ...mapState('pudo', ['selectedCountry', 'selectedCustomer']),
    ...mapGetters('personalSettings', ['defaultCountries', 'defaultCustomers']),
    ...mapGetters('user', ['getCountryPermissions', 'getCustomerPermissions']),
    ...mapGetters('country', ['countryOptions']),
    ...mapGetters('customer', ['customerOptions'])
  },
  created () {
    if (this.selectedCountry !== -1) {
      this.Country = find(this.countryOptions, { value: this.selectedCountry })
    } else if (this.getCountryPermissions.length === 1) {
      this.Country = find(this.countryOptions, { value: this.getCountryPermissions[0] })
    } else if (this.defaultCountries && this.defaultCountries.length === 1) {
      this.Country = find(this.countryOptions, { value: this.defaultCountries[0] })
    }
    if (this.selectedCustomer !== -1) {
      this.Customer = find(this.customerOptions, { value: this.selectedCustomer })
    } else if (this.getCustomerPermissions.length === 1) {
      this.Customer = find(this.customerOptions, { value: this.getCustomerPermissions[0] })
    } else if (this.defaultCustomers && this.defaultCustomers.length === 1) {
      this.Customer = find(this.customerOptions, { value: this.defaultCustomers[0] })
    }
  },
  methods: {
    ...mapMutations('pudo', ['setSelectedCountry', 'setSelectedCustomer']),
    emitChange (reason) {
      this.$emit('input', {
        From_Date: moment(this.dateFrom).format(),
        To_Date: moment(this.dateTo).format(),
        Customers: (this.Customer ? [this.Customer.value] : []),
        Countries: (this.Country ? [this.Country.value] : []),
        Current_Event_Infos: [],
        Parcel_Status: [],
        Service_Levels: [],
        Show_Forward_Flow: true,
        From_Postal_Code: '',
        To_Postal_Code: ''
      })
    },
    saveCountry (value) {
      this.setSelectedCountry(value.value)
    },
    saveCustomer (value) {
      this.setSelectedCustomer(value.value)
    }
  }
}
</script>

<style lang="scss">
@import '../../variables.scss';

.spl-pudo-filter {
  background-color: $yellowButtonLabelHover;
  padding: 10px $mainPadding;
  margin-bottom: 15px;
  display: flex;
  flex-direction: row;
  & .spl-datepicker {
    margin-right: 10px;
  }
  & .multiselect {
    width: 250px;
    margin-right: 10px;
    z-index: 5;
  }
  &__apply {
    margin-top: 22px;
    margin-bottom: 3px;
  }
}

</style>
